/* Retire append-only Building backups. Purchased-line properties remain untouched. */
(function () {
  if (window.clearBuilderCartBackups) return;
  var running = null;
  function legacyKeys(attributes) {
    return Object.keys(attributes || {}).filter(function (key) {
      if (!/^Building (?:[0-9a-f]{8}-[0-9a-f-]{27}|b-[a-z0-9]+|\d+)$/i.test(key)) return false;
      try {
        var record = JSON.parse(attributes[key]);
        return record && /^3D Shed Builder\b/.test(record['_Built with'] || record['__Built with'] || '') &&
          typeof (record['_Building specification'] || record['__Building specification']) === 'string';
      } catch (_) { return false; }
    });
  }
  async function request(path, data) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch(root + path, {method: data ? 'POST' : 'GET', cache: 'no-store',
        headers: data ? {'Content-Type':'application/json'} : {},
        body: data ? JSON.stringify(data) : undefined, signal: controller.signal});
      if (!response.ok) throw Error('Could not refresh basket details');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  window.clearBuilderCartBackups = function () {
    if (running) return running;
    running = (async function () {
      var cart = await request('cart.js'), keys = legacyKeys(cart.attributes);
      if (!keys.length) return cart;
      var attributes = {}; keys.forEach(function (key) { attributes[key] = ''; });
      var result = await request('cart/update.js', {attributes: attributes});
      if (legacyKeys(result.attributes).length) throw Error('Old building details could not be cleared');
      return result;
    })().finally(function () { running = null; });
    return running;
  };
  var style = document.createElement('style');
  style.textContent = 'html[data-builder-cleanup-pending] .additional-checkout-buttons{visibility:hidden;pointer-events:none}';
  document.head.appendChild(style);
  async function refresh() {
    document.documentElement.setAttribute('data-builder-cleanup-pending','');
    try { await window.clearBuilderCartBackups(); document.documentElement.removeAttribute('data-builder-cleanup-pending'); }
    catch (_) { /* The ordinary checkout button allows a retry without discarding the basket. */ }
  }
  var resumeForm = null;
  document.addEventListener('submit', function (event) {
    var form = event.target, button = event.submitter;
    if (resumeForm === form) { resumeForm = null; return; }
    if (!button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    window.clearBuilderCartBackups().then(function () {
      document.documentElement.removeAttribute('data-builder-cleanup-pending');
      resumeForm = form; form.requestSubmit(button); resumeForm = null;
    }).catch(function () { window.alert('Please try checkout again. We could not refresh your basket details. Your items are still in your basket.'); });
  }, true);
  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('theme:cart:init', refresh);
  window.addEventListener('pageshow', refresh);
  refresh();
})();